import React from 'react'
import { ErrorModel } from './types'
import ErrorPage from 'features/errors/ui/ErrorPage'

interface Props {
  FallBackComponent?: React.FC<{ error: Error }>
}

interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends React.Component<React.PropsWithChildren<Props>, State> {
  static getDerivedStateFromError() {
    return {
      hasError: true
    }
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      hasError: false,
      error: null
    }
  }

  componentDidCatch(error: ErrorModel) {
    console.error('ErrorBoundary caught an error:', error)
    this.setState((prevState) => ({
      ...prevState,
      hasError: true,
      error
    }))
  }

  render() {
    if (this.state.hasError) {
      if (this.props.FallBackComponent) {
        const FallBackComponent = this.props.FallBackComponent

        return <FallBackComponent error={this.state.error as Error} />
      }

      return <ErrorPage code="500" />
    }

    return this.props.children
  }
}
